import { updateCoverage } from '@/api/agency-coverage-api';
import { useQuoteStore } from './use-quote-store';
import { reportError } from '@/services/error-reporting-service';

const REQUOTE_REQUIRED_KINDS = new Set(['tort_selection']);
const SCROLL_POSITION_KEY = 'recalculation_scroll_position';

export const requiresRequoteRedirect = (kind: string): boolean => {
  return REQUOTE_REQUIRED_KINDS.has(kind.toLowerCase());
};

export const fireUpdateAndRedirect = (): void => {
  const quote = useQuoteStore.getState().quote;
  if (!quote) return;

  sessionStorage.setItem(SCROLL_POSITION_KEY, window.scrollY.toString());

  updateCoverage(
    {
      coverages: quote.coverages,
      invoice_period: quote.details.initial_term_selection,
    },
    { keepalive: true }
  ).catch((error) => {
    reportError({ error });
  });

  // Use the agency API router to determine the appropriate scene while requoting
  window.location.assign('/');
};

export const restoreScrollPosition = (): void => {
  const saved = sessionStorage.getItem(SCROLL_POSITION_KEY);
  if (saved) {
    sessionStorage.removeItem(SCROLL_POSITION_KEY);
    window.scrollTo(0, parseInt(saved));
  }
};
